import { render, staticRenderFns } from "./ComparisonBarChart.vue?vue&type=template&id=7ff40e06&scoped=true&"
import script from "./ComparisonBarChart.vue?vue&type=script&lang=ts&"
export * from "./ComparisonBarChart.vue?vue&type=script&lang=ts&"
import style0 from "./ComparisonBarChart.vue?vue&type=style&index=0&id=7ff40e06&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff40e06",
  null
  
)

export default component.exports